import lifecycle from 'recompose/lifecycle';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { renderNothing } from 'recompose';
import { redirectToRegister } from '../../../main/payment/actions';
import { getIsOrderEmpty } from '../../order/selectors';

const RedirectEmptySale = compose(
  connect(
    state => ({
      isEmpty: getIsOrderEmpty(state),
    }),
    { redirectToRegister }
  ),
  lifecycle({
    componentDidMount() {
      if (this.props.isEmpty) this.props.redirectToRegister();
    },
  })
)(renderNothing());

export default RedirectEmptySale;
